import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
export const SoldBanner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={twMerge("absolute top-1/2 right-30 left-30 -translate-y-1/2 transform rounded-lg px-4 py-2", "bg-zinc-800/80 text-center font-serif text-xl font-semibold tracking-wider text-zinc-100 italic")}>SOLD</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};